// extracted by mini-css-extract-plugin
module.exports = {"gpt":"gpt___GEJ0f"};